document.addEventListener('click', function (event) {
  var trigger = event.target.closest('#open-rewards-popup');
  if (!trigger) return;

  event.preventDefault();

  var openWithApi = function () {
    if (window.SmileUI && typeof window.SmileUI.openPanel === 'function') {
      window.SmileUI.openPanel();
      return true;
    }

    return false;
  };

  var clickLiteIframeButton = function () {
    var launcherFrame = document.querySelector('#smile-lite-launcher-frame');
    if (!launcherFrame) return false;

    try {
      var frameDoc = launcherFrame.contentDocument || (launcherFrame.contentWindow && launcherFrame.contentWindow.document);
      var frameButton = frameDoc && frameDoc.querySelector('button[aria-label="Open Smile.io Rewards Program"]');

      if (frameButton) {
        frameButton.click();
        return true;
      }
    } catch (error) {
    }

    return false;
  };

  var clickLauncher = function () {
    if (openWithApi()) return true;

    if (clickLiteIframeButton()) return true;

    var launcherContainer = document.querySelector('#smile-ui-lite-launcher-frame-container');
    var launcherFrame = document.querySelector('#smile-lite-launcher-frame');

    if (launcherContainer) {
      launcherContainer.click();
      return true;
    }

    if (launcherFrame) {
      launcherFrame.click();
      return true;
    }

    console.log('[Rewards CTA] Launcher not ready yet');
    return false;
  };

  if (clickLauncher()) return;

  window.setTimeout(function () {
    openWithApi() || clickLauncher();
  }, 250);

  window.setTimeout(function () {
    openWithApi() || clickLauncher();
  }, 800);

  if (window.__rewardsSmileOpenTimer) {
    window.clearInterval(window.__rewardsSmileOpenTimer);
  }

  var attempts = 0;
  var maxAttempts = 40;
  window.__rewardsSmileOpenTimer = window.setInterval(function () {
    attempts += 1;

    if (clickLauncher() || attempts >= maxAttempts) {
      window.clearInterval(window.__rewardsSmileOpenTimer);
      window.__rewardsSmileOpenTimer = null;
    }
  }, 150);
});
